<template>
    <UsersTable
        class="users-page__table"
        :users="customers"
        :sorting-fields="sortingFields"
        :selectable="false"
    >
        <template #head-rows>
            <th style="width: 10%" class="control-table__cell users-table__cell">
                <div class="control-table__cell-inner">
                    ID
                    <TableSorting
                        v-if="sortingFields.includes('id')"
                        v-model="ordering"
                        field="id"
                    />
                </div>
            </th>
            <th
                style="width: 20%; min-width: 200px; max-width: 250px"
                class="control-table__cell users-table__cell"
            >
                <div class="control-table__cell-inner">
                    {{ $t('crm.customers.list.name') }}
                    <TableSorting
                        v-if="sortingFields.includes('name')"
                        v-model="ordering"
                        field="name"
                    />
                </div>
            </th>
            <th style="width: 30%" class="control-table__cell users-table__cell">
                <div class="control-table__cell-inner">
                    {{ $t('crm.customers.list.type') }}
                </div>
            </th>
        </template>
        <template #item-rows="{ user: customer }">
            <td class="control-table__cell">
                {{ customer.id }}
            </td>
            <td class="control-table__cell">
                <router-link
                    :to="{
                        name: 'customers-id',
                        params: {
                            id: customer.id,
                        },
                    }"
                >
                    <b>{{ customer.name }}</b>
                </router-link>
            </td>
            <td class="control-table__cell">
                {{ customer.type_productions.label }}
            </td>
        </template>
    </UsersTable>
</template>

<script>
import { UsersTable } from '../../../users/components';
import TableSorting from '@speechki-frontend/shared/ui/TableSorting';
import { mapGetters } from 'vuex';

export default {
    name: 'CustomersTable',
    components: {
        UsersTable,
        TableSorting,
    },
    props: {
        customers: {
            type: Array,
            default: () => [],
        },
        sortingFields: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            ordering: '-id',
        };
    },
    computed: {
        ...mapGetters(['isAdmin']),
    },
    watch: {
        ordering() {
            this.$emit('sort', this.ordering);
        },
    },
};
</script>

<style src="./CustomersTable.scss" lang="scss"></style>
